import React from 'react';
import { List } from 'semantic-ui-react';
import clsx from 'clsx';
import { findError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import { propertiesWithValue } from '@/utils/resultsHelper';
import FormListItemContainer from './FormListItemContainer';
import { shouldDisplayFormField } from '../helper';

const FormListItem = ({
  autoFocus,
  canEdit,
  category,
  component,
  code,
  direction,
  field,
  hideLabel,
  isEditing,
  onChange,
  saveErrors,
  saveStatus,
  section,
  showEdit,
  text,
}) => {
  if (!shouldDisplayFormField(canEdit, component, text, field)) {
    return null;
  }

  const onValueChange = (value) => (
    onChange({ properties: propertiesWithValue(field, value), names: [field.name] })
  );

  const FieldComponent = component.component;
  const FieldEditor = component.editor;
  const error = findError(saveErrors, section, [field.name], true);

  return (
    <List.Item className={clsx(
      'aridhia-form-field-list-item',
      `form-field-item-${field.type}`,
      isEditing && 'form-editing-field-item',
    )}
    >
      <FormListItemContainer
        error={error}
        field={field}
        hasLabel={component.hasLabel}
        hideLabel={hideLabel}
        isEditing={isEditing}
      >
        <FieldComponent
          canEdit={canEdit}
          category={category}
          code={code}
          field={field}
          onChange={onValueChange}
          section={section}
          showEdit={showEdit}
          text={text}
        />
      </FormListItemContainer>
      {canEdit && isEditing && FieldEditor && (
      <FieldEditor
        autoFocus={autoFocus}
        category={category}
        code={code}
        direction={direction}
        disabled={saveStatus === states.PENDING}
        error={error}
        field={field}
        onChange={onValueChange}
        section={section}
        text={text}
      />
      )}
    </List.Item>
  );
};

export default FormListItem;
